import { render, staticRenderFns } from "./BriefProfile.vue?vue&type=template&id=74fff2c6&"
import script from "./BriefProfile.vue?vue&type=script&lang=js&"
export * from "./BriefProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports